import React, { useState } from "react";
import MessageBox from "../../shared/form-message-box";
import FormResult from "../../shared/form-result";
import axios from "axios";

declare global {
	interface Window {
		gextContactForm: {
			ajaxUrl: string;
			nonce: string;
		};
	}
}

export default function ContactForm() {
	const gextContactForm = window.gextContactForm;
	const [isLoading, setIsLoading] = useState(false);
	const [isSuccess, setIsSuccess] = useState(false);
	const [message, setMessage] = useState<string | null>(null);

	const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		setIsLoading(true);
		const formData = new FormData(e.currentTarget);
		formData.append("action", "gext_contact_form_submit");
		formData.append("nonce", gextContactForm.nonce);

		try {
			const response = await axios.postForm(
				gextContactForm.ajaxUrl,
				formData,
			);

			console.log(response);

			const result = response.data;

			if (result.success) {
				setIsSuccess(true);
				setMessage(result.data.message);
			} else {
				setIsSuccess(false);
				setMessage(result.data.message || "Une erreur est survenue.");
			}
		} catch (error) {
			setIsSuccess(false);
			setMessage(
				"Une erreur de connexion est survenue. Veuillez réessayer.",
			);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<>
			{!isSuccess && (
				<>
					<MessageBox
						message={message}
						isSuccess={isSuccess}
						isLoading={isLoading}
					/>
					<form
						className="gext-form__form"
						method="post"
						onSubmit={onSubmit}
					>
						<div className="gext-form__fields-grid">
							<div className="gext-form__field">
								<label htmlFor="gext-name">
									Nom <span className="required">*</span>
								</label>
								<input
									type="text"
									id="gext-name"
									name="name"
									required
								/>
							</div>

							<div className="gext-form__field">
								<label htmlFor="gext-address">
									Adresse <span className="required">*</span>
								</label>
								<input
									type="text"
									id="gext-address"
									name="address"
									required
								/>
							</div>

							<div className="gext-form__field">
								<label htmlFor="gext-company">
									Entreprise <span className="required">*</span>
								</label>
								<input
									type="text"
									id="gext-company"
									name="company"
									required
								/>
							</div>

							<div className="gext-form__field">
								<label htmlFor="gext-position">
									Poste dans l'entreprise{" "}
									<span className="required">*</span>
								</label>
								<input
									type="text"
									id="gext-position"
									name="position"
									required
								/>
							</div>

							<div className="gext-form__field">
								<label htmlFor="gext-email">
									Email <span className="required">*</span>
								</label>
								<input
									type="email"
									id="gext-email"
									name="email"
									required
								/>
							</div>

							<div className="gext-form__field">
								<label htmlFor="gext-phone">
									Téléphone <span className="required">*</span>
								</label>
								<input
									type="tel"
									id="gext-phone"
									name="phone"
									required
								/>
							</div>

							<div className="gext-form__field gext-form__field--full">
								<label htmlFor="gext-message">
									Message <span className="required">*</span>
								</label>
								<textarea
									id="gext-message"
									name="message"
									rows={5}
									required
								></textarea>
							</div>

							<div className="gext-form__checkboxe_field">
								<input
									type="checkbox"
									id="gext-accepts-occasional-news"
									name="accepts_occasional_news"
								/>
								<label htmlFor="gext-accepts-occasional-news">
									Je souhaite être averti des nouvelles
									importantes autour du Décret Tertiaire
								</label>
							</div>

							<div className="gext-form__checkboxe_field">
								<input
									type="checkbox"
									id="gext-accepts-newsletter"
									name="accepts_newsletter"
								/>
								<label htmlFor="gext-accepts-newsletter">
									Je souhaite recevoir la newsletter du Décret
									Tertiaire
								</label>
							</div>
							<div className="gext-form__submit">
								<button type="submit" disabled={isLoading}>
									{isLoading ? "Envoi en cours..." : "Envoyer"}
								</button>
							</div>
						</div>
					</form>
				</>
			)}
			{isSuccess && (
				<FormResult
					variant="success"
					title="Message bien reçu !"
					descriptions={[
						"Nous avons bien reçu votre message et nous vous remercions de votre intérêt pour nos services d'accompagnement au Décret Tertiaire.",
						"Un membre de notre équipe prendra contact avec vous dans les plus brefs délais pour répondre à votre demande. Nous nous engageons à vous répondre sous 48 heures ouvrées.",
						<><strong>En attendant :</strong> N'hésitez pas à consulter nos ressources et articles sur le Décret Tertiaire pour mieux comprendre vos obligations et les opportunités d'économies d'énergie.</>,
					]}
				/>
			)}
		</>
	);
}
